/* Used global Wordpress php variables to the ajax requests */
/* global themeVars */

/**
 * Theme Settings
 */
const themeSettings = { ...themeVars }

/**
 * Menu
 * @type {Array}
 */
const menus = themeSettings.menus || [];

/**
 * Multimedia icons
 *
 * @type {Array}
 *
 * @property {string} name - The name of the category.
 * @property {string} termSlug - The slug of the category.
 * @property {string} color - The color of the category.
 */
const multimediaIcons = [
	{ termSlug: 'podcasty', icon: `${themeVars.templateUrl}/img/multimedia/icon-podcasts.png` },
	{ termSlug: 'shortsy', icon: `${themeVars.templateUrl}/img/multimedia/icon-shorts.png` },
	{ termSlug: 'wideo', icon: `${themeVars.templateUrl}/img/multimedia/icon-video.png` },
	{ termSlug: 'wideocasty', icon: `${themeVars.templateUrl}/img/multimedia/icon-wideocasty.png` }
];

/**
 * Get the post ID control status
 *
 * @return {Array} The post ID control status
 */
const selectPostIDControlStatus = Array.isArray( themeVars.selectPostIDControllStatus ) ? themeVars.selectPostIDControllStatus : ['public'];

/**
 * Categories colors
 *
 * @type {Array}
 *
 * @property {string} name - The name of the category.
 * @property {string} slug - The slug of the category.
 * @property {string} color - The color of the category.
 */
const categoriesColors = [
	{ name: 'Business', slug: 'business', color: '#0068ce' },
	{ name: 'Analysis', slug: 'analysis', color: '#8b07e0' },
	{ name: 'Technology', slug: 'technology', color: '#00b2e2' },
	{ name: 'Politics', slug: 'politics', color: '#8a8a8f' },
	{ name: 'World', slug: 'world', color: '#15af04' },
	{ name: 'Sports', slug: 'sports', color: '#ff7d08' },
	{ name: 'Lifestyle', slug: 'lifestyle', color: '#ff579c' },
	{ name: 'News', slug: 'news', color: '#ce0000' },
	{ name: 'Special Events', slug: 'special-events', color: '#ffe210' },
];

/**
 * Allowed blocks for the post container
 */
const postContainerAllowedBlocks = [
	'core/paragraph',
	'core/heading',
	'core/image',
	'core/list',
	'core/list-item',
	'core/quote',
	'core/table',
	'core/verse',
	'core/code',
	'core/html',
	'core/embed',
	'wombat/content-insights',
	'wombat/read-more',
	'wombat/table-extended',
	'wombat/series-partner',
	'wombat/media-tabs',
	'wombat/media-tabs-onnetwork',
	'wombat/conclusions',
	'wombat/expert-insight',
	'wombat/good-to-know',
	'wombat/datawrapper-chart',
	'wombat/mini-interview',
	'wombat/accordion',
	'wombat/download-file',
	'wombat/typeform',
	'wombat/newsletter-container',
	'wombat/cta-link',
]

/**
 * Array of font styles for heading.
 *
 * @type {Array}
 * @property {string} label - The label of the font style.
 * @property {string} value - The value of the font style.
 */
const headingFontsStyles = [

	// Responsive
	{
		label: 'Responsive: Display L',
		value: 'has-fs-r-display-l'
	},
	{
		label: 'Responsive: Display M',
		value: 'has-fs-r-display-m'
	},
	{
		label: 'Responsive: Display S',
		value: 'has-fs-r-display-s'
	},
	{
		label: 'Responsive: Heading 1',
		value: 'has-fs-r-heading-1'
	},
	{
		label: 'Responsive: Heading 2',
		value: 'has-fs-r-heading-2'
	},
	{
		label: 'Responsive: Heading 3',
		value: 'has-fs-r-heading-3'
	},
	{
		label: 'Responsive: Heading 4',
		value: 'has-fs-r-heading-4'
	},
	// Static
	{
		label: 'Static: Heading 1',
		value: 'has-fs-s-heading-1'
	},
	{
		label: 'Static: Heading 2',
		value: 'has-fs-s-heading-2'
	},
	{
		label: 'Static: Heading 3',
		value: 'has-fs-s-heading-3'
	},
	{
		label: 'Static: Heading 4',
		value: 'has-fs-s-heading-4'
	},

];

/**
 * Array of font styles for paragraph
 *
 * @type {Array}
 * @property {string} label - The label of the font style.
 * @property {string} value - The value of the font style.
 */
const paragraphFontsStyles = [

	// Static
	{
		label: 'Body text',
		value: 'has-fs-s-body-text'
	},
	{
		label: 'Body Small',
		value: 'has-fs-s-body-small'
	},
	{
		label: 'Small',
		value: 'has-fs-s-small'
	},
	{
		label: 'Caption',
		value: 'has-fs-s-caption'
	},
	{
		label: 'Lead',
		value: 'has-fs-s-lead'
	},
	{
		label: 'Overline',
		value: 'has-fs-s-overline'
	},

];

export { themeSettings, categoriesColors, postContainerAllowedBlocks, headingFontsStyles, paragraphFontsStyles, multimediaIcons, selectPostIDControlStatus, menus };
